/**
 * Ad slot config — drop new promoted units in here without touching component code.
 * Each entry can be shown in one or more placements. To take an ad down, set enabled=false.
 *
 * Placements currently in use:
 *   - marketplace-inline  → renders as a card in the marketplace grid every ~6 items
 *   - marketplace-sidebar → sticky sidebar on desktop marketplace
 *   - community-inline    → in-feed on community
 *   - community-sidebar   → sticky sidebar on community
 */
export const ADS = [
    {
        id: "booty-breeze-launch",
        enabled: true,
        placements: ["marketplace-inline", "marketplace-sidebar", "community-inline", "community-sidebar"],
        sponsor: "Booty Breeze",
        headline: "Ride smells like burnouts?",
        subhead: "Booty Breeze air fresheners — engineered for guys who go WOT.",
        cta: "Shop Booty Breeze",
        href: "https://bootybreeze.com",
        accent: "#E10600",
        emoji: "🔥",
        badge: "AD",
    },
];

export function getAdFor(placement) {
    const pool = ADS.filter((a) => a.enabled && a.placements.includes(placement));
    if (!pool.length) return null;
    // Rotate deterministically by minute so the same visitor sees stable ordering
    const bucket = Math.floor(Date.now() / (1000 * 60)) % pool.length;
    return pool[bucket];
}
